<div class="gallery container-fluid">

  <div class="d-flex justify-content-center"><h1 style="font-size: 4rem;">Gallery</h1></div>
  <div class="d-flex justify-content-center" style="margin-bottom: 3rem">
    <div class="motif__1">
      <img src="../../assets/images/processpage/10091105.png" alt="" />
    </div>
  </div>

  <div class="content container-fluid">
    <div class="grid">
    <figure (click)="naviagate(item.id)"
      class="effect-bubba"
      *ngFor="let item of data"
    >
      <img
        style="width: 100%"
        src="../../assets/images/uploads/{{item.image}}"
      />
      <figcaption>
        <h2 style="word-spacing: 5px;font-family: Roboto,sans-serif !important;">
          {{item.name | split}} <span> {{item.name | rest}} </span>
        </h2>
        <p>
          {{item.description | truncate:[150, '...'] }}
        </p>
      </figcaption>
    </figure>
    </div>
  </div>

  <div *ngIf="loaded == false" id="container-loader">
    <div class="divider" aria-hidden="true"></div>
    <p class="loading-text" aria-label="Loading">
      <span class="letter" aria-hidden="true">L</span>
      <span class="letter" aria-hidden="true">o</span>
      <span class="letter" aria-hidden="true">a</span>
      <span class="letter" aria-hidden="true">d</span>
      <span class="letter" aria-hidden="true">i</span>
      <span class="letter" aria-hidden="true">n</span>
      <span class="letter" aria-hidden="true">g</span>
    </p>
  </div>
</div>
